export default {
  accept: ['ja', 'ja-jp'],
  native: '日本語',
  ll_CC: 'ja_JP',

  menu: {
    clone: 'セーブ ロード',
    aboutFeeles: 'この Feeles について',
    you: 'あなた',
    version: 'バージョン',
    showAllUrls: '全ての URL を表示'
  },
  cloneDialog: {
    saveTitle: 'セーブ',
    saveHeader: 'ブラウザにデータを保存する',
    loadTitle: 'ロード',
    loadHeader: 'ブラウザからデータを読み込む',
    overwriteSave: '上書きして保存',
    saveInNew: '新しいスロットに保存',
    remove: 'このデータを削除する',
    openOnThisTab: 'このデータをロードする',
    openInNewTab: '新しいタブで開く',
    created: '作成日時',
    updated: '更新日時',
    size: 'データサイズ',
    project: 'プロジェクトを JSON で書き出す',
    save: '保存する',
    cancel: 'キャンセル',
    saveHTML: 'HTMLだけ保存する',
    saveLibrary: 'ライブラリだけ保存する',
    saveAll: 'どちらも保存する',
    failedToSave: 'アプリの保存に失敗しました',
    failedToRemove: 'アプリの削除に失敗しました',
    failedToOpenTab:
      'ポップアップがブロックされたため、アプリの読み込みに失敗しました',
    failedToRename: '同じタイトルのプロジェクトを二つ作ることはできません',
    titleIsRequired: 'プロジェクトにはタイトルを必ずつけてください',
    autoSaved: 'オートセーブされています',
    setTitle: 'タイトルをつけてください'
  },
  saveDialog: {
    title: '',
    description: (filename: string) =>
      `上のリンクを右クリックして、「別名でダウンロード」をクリックし、「${filename}」という名前をつけて保存して下さい`,
    cancel: 'キャンセル'
  },
  aboutDialog: {
    title: '',
    coreVersion: 'Feelse のバージョン',
    changeVersion: 'バージョンを変更',
    change: '変更'
  },
  launchDialog: {
    title: '',
    description:
      '途中のデータが残っています。続きから始めたい場合は、「このデータをロードする」をクリックしてください',
    openProject: 'このプロジェクトを開く',
    startNew: '今すぐスタート'
  },
  addDialog: {
    title: '',
    fileName: 'ファイル名',
    add: '作成',
    cancel: 'キャンセル'
  },
  shotCard: {
    title: 'マドウショ',
    shoot: '書きかえたら、',
    button: 'コードをおくる',
    restore: '元にもどす'
  },
  hierarchyCard: {
    title: '',
    emptyTrashBox: '空にする'
  },
  common: {
    clickToSelect: 'クリックで えらぶ',
    close: 'とじる',
    tapTwiceQuickly: 'すばやく２回クリックすると変更できます',
    cannotBeUndone: 'この操作は取り消せません',
    editFile: '書きかえる',
    conflict: '同じ名前のファイルがすでに存在します。上書きしますか？',
    or: 'または',
    wantToOpen: (name: string) => `${name} をひらきますか?`
  },
  editorCard: {
    title: '',
    replaceToOtherAsset: '別のアセットに入れかえる',
    currentAsset: '今のアセット',
    selectedAsset: '入れかえるアセット',
    replace: '入れかえる',
    replaceNotice:
      '見た目だけでなく、うごきも全くちがう別のキャラクターになります',
    youCanNotUsePaidAssets:
      '無料版では一部のアセットが制限されています。月額会員になると全て使えるようになります',
    seeMore: '詳しく見る',
    replaceToOtherSkin: 'スキン（見た目）をかえる',
    currentSkin: '今のスキン',
    selectedSkin: '入れかえるスキン',
    playAfterEdit: 'コードをかえたら、プレイをクリック！',
    insertTo: (name: string) => `${name} に ついか`,
    insertToStage: `ステージに ついか`,
    undo: 'もどす',
    play: 'プレイ',
    notice: 'このタブはまだセーブされていません。本当によろしいですか？',
    insert: 'コードをついか',
    onceMoreInsert: 'もう一回 コードをついか する',
    edit: (name: string) => `${name} の中身を見る`,
    stopEditing: (name: string) => `${name} の改造をおわる`,
    error: '😇💭 あっ、ちょっと 入力ミスが...',
    errorFollow: '入力ミスは　だれにだってある。',
    restore: 'ミスがおこる まえにもどす',
    copy: 'コピーする',
    copied: 'コピーできた！',
    cut: 'きりとる',
    paste: 'はりつける',
    sendCode: 'コードをおくる',
    deleteLine: 'コードを消す',
    copyLine: 'コードをコピー',
    pasteLine: '貼り付ける',
    clickHere: '⭐️ まずは ここをクリック',
    selectedScope: 'に 入れるもの',
    hankaku: `全角文字を、半角文字にしました`,
    lineBreakInString: `文字列の途中では改行できません. \\n を使ってみてください`,
    ok: `わかった`,
    needPayment: `これを使うには、ログインして月額プランに加入する必要があります`,
    noAssetAt: (name: string) =>
      `このファイルについかできる「${name}」はありません`,
    noAssetDescription:
      '他のファイルを開く（キャラクターの中身を見る）には、キャラクターのアイコンをクリックしてください',
    stopAction: 'この機能を停止'
  },
  envCard: {
    title: '',
    remove: '削除'
  },
  monitorCard: {
    title: '',
    mapSelector: (name: string) => `${name} の はいけいを かえる`,
    mapSelectorTitle: `好きな はいけいを えらぼう`,
    officials: '公式マップ',
    yours: '自分のマップ',
    reload: '再読みこみ',
    open: 'ひらく',
    confirm: 'けってい'
  },
  customizeCard: {
    title: '',
    detail: 'くわしくはこちら',
    editor: 'タブや行の折り返しなど',
    style: '文字の色や背景色など'
  },
  mediaCard: {
    title: ''
  }
};
